// extracted by mini-css-extract-plugin
module.exports = {"outline_btn":"Button_outline_btn__3cOfg","full_width":"Button_full_width__S-USu","solid_btn":"Button_solid_btn__35DS7","disable":"Button_disable__1-h25"};